"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/History/Desktop/ParticipantDetails.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);








const ParticipantDetails = ({
  participantName,
  startedAt,
  duration,
  rating,
}) => (
  _react2.default.createElement('div', { className: "meeting--table-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
    , _react2.default.createElement('div', { className: "meeting--table-col participant-col" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
      ,  participantName || 'Unknown' 
    )
    , _react2.default.createElement('div', { className: "meeting--table-col time-col" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, startedAt)
    , _react2.default.createElement('div', { className: "meeting--table-col duration-col" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}, duration)
    , _react2.default.createElement('div', { className: "meeting--table-col feedback-col" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
      ,  Array(5).fill(0).map((_, i) => (
          _react2.default.createElement('div', {
            key: i,
            className: _classBuilder2.default.call(void 0, 
              "meeting-room--history--details-feedback-point",
              // A missing rating compares like 0 in JS: no point is active.
              { active: i + 1 <= (_nullishCoalesce(rating, () => ( 0))) },
            ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
          )
      ))
      
    )
  )
)

exports. default = ParticipantDetails
